(() => {
  if (customElements.get('titanx-landing')) return;
  class TitanxLanding extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.controller = new AbortController();
      const on = (element, type, fn) => element?.addEventListener(type, fn, {signal: this.controller.signal});
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-variant]');
      this.status = this.querySelector('[data-status]');
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.busy = false;
      const image = this.querySelector('[data-main-image]');
      this.querySelectorAll('[data-gallery]').forEach(button => on(button, 'click', () => {
        if (image) {image.src = button.dataset.gallery; image.alt = button.dataset.alt;}
        this.querySelectorAll('[data-gallery]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
      on(this.select, 'change', () => this.updateVariant(true));
      this.querySelectorAll('[data-model-choice]').forEach(button => on(button, 'click', () => {
        if (!this.select || button.disabled) return;
        this.select.value = button.dataset.modelChoice;
        this.updateVariant(true);
        this.form?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        this.select.focus({preventScroll:true});
      }));
      this.updateVariant(false);
      on(this.form, 'submit', async event => {
        if (!window.fetch || this.dataset.preview === 'true') {
          if (this.dataset.preview === 'true') {event.preventDefault(); this.message('Vista previa: la compra se habilita al instalar la sección en Shopify.', false);}
          return;
        }
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const variant = this.variants.find(v => String(v.id) === this.select.value);
        if (!variant?.available) {this.message('Elegí una variante disponible para tu iPhone.', true); return;}
        const qty = Number(this.form.elements.quantity.value);
        if (!Number.isInteger(qty) || qty < 1) {this.message('La cantidad debe ser un número entero mayor a cero.', true); return;}
        this.busy = true; this.setButtons(true); this.message('Agregando tu TITANX…', false);
        const root = this.dataset.cartRoot || '/';
        try {
          const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:variant.id,quantity:qty}]}), credentials:'same-origin'});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar el producto. Revisá la disponibilidad.');
          window.location.assign(root + (event.submitter?.value === '/checkout' ? 'checkout' : 'cart'));
        } catch (error) {
          this.busy = false; this.updateVariant(false); this.message(error.message || 'No se pudo conectar. Probá nuevamente.', true);
        }
      });
      const video = this.querySelector('video');
      const sound = this.querySelector('[data-sound]');
      const play = this.querySelector('[data-play]');
      if (video) {
        video.muted = true; video.playsInline = true;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {video.autoplay = false; video.pause();}
        else video.play().catch(() => {if(play) play.textContent = 'Reproducir video';});
        on(sound, 'click', () => {video.muted = !video.muted; sound.textContent = video.muted ? 'Activar sonido' : 'Silenciar'; sound.setAttribute('aria-pressed', String(!video.muted)); if (video.paused) video.play().catch(() => this.message('Usá los controles del video para reproducirlo.', false));});
        on(play, 'click', () => {if(video.paused) video.play().catch(() => {play.textContent='Reproducir video';}); else video.pause();});
        on(video, 'play', () => {if(play) play.textContent='Pausar video';});
        on(video, 'pause', () => {if(play) play.textContent='Reproducir video';});
        if (play) play.textContent = video.paused ? 'Reproducir video' : 'Pausar video';
      }
    }
    message(text, error) {if(this.status) {this.status.textContent=text;this.status.dataset.error=String(error);}}
    setButtons(disabled) {this.querySelectorAll('[data-purchase]').forEach(b => {b.disabled=disabled; b.setAttribute('aria-disabled',String(disabled));});}
    updateVariant(changeUrl) {
      if (!this.select) return;
      const variant = this.variants.find(v => String(v.id) === this.select.value);
      this.setButtons(this.busy || !variant?.available);
      this.querySelectorAll('[data-model-choice]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.modelChoice === this.select.value)));
      if (!variant) {this.message('Seleccioná tu modelo para continuar.',false);return;}
      this.querySelector('[data-price]').textContent = variant.formattedPrice;
      const sticky = this.querySelector('[data-sticky-price]'); if(sticky) sticky.textContent=variant.formattedPrice;
      const compare = this.querySelector('[data-compare]'); if(compare) {compare.hidden=!(variant.compare > variant.price); compare.textContent=variant.formattedCompare;}
      this.message(variant.available ? 'Modelo seleccionado: '+variant.title : 'Este modelo está agotado.', !variant.available);
      if (variant.image) {const image=this.querySelector('[data-main-image]');image.src=variant.image;image.alt='TITANX compatible con '+variant.title;this.querySelectorAll('[data-gallery]').forEach(b=>b.setAttribute('aria-pressed','false'));}
      if(changeUrl && this.dataset.preview !== 'true') {const url=new URL(location.href);url.searchParams.set('variant',this.select.value);history.replaceState(null,'',url);}
    }
    disconnectedCallback() {this.controller?.abort();this._ready=false;}
  }
  customElements.define('titanx-landing', TitanxLanding);
})();
